import { render, staticRenderFns } from "./BillingAndInvoices.vue?vue&type=template&id=3710d3c2"
import script from "./BillingAndInvoices.vue?vue&type=script&lang=js"
export * from "./BillingAndInvoices.vue?vue&type=script&lang=js"
import style0 from "./BillingAndInvoices.vue?vue&type=style&index=0&id=3710d3c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports